import React, { PropTypes } from 'react';

const AuditSearchBowler = ({
  bowlerId,
  bowlerNationalId,
  bowlerName,
  tournamentName,
  teamName,
  captainName,
  coordinatorName,
  onNavigationClick
}) => {
  if (teamName && teamName.length > 0)
    return (
      <div className="list-group-item-labeled">
        <div className="list-group-item-labeled-child"
          style={{ width: 200 }}>
          <span>{'Tournament'}</span>
          <span>{`${tournamentName}`}</span>
        </div>
        <div className="list-group-item-labeled-child"
          style={{ width: 150 }}>
          <span>{'Name'}</span>
          <span>{`${bowlerName}`}</span>
        </div>
        <a className="list-group-item-labeled-child has-link"
          style={{ width: 80 }}
          onClick={() => onNavigationClick(`admin/audit/bowler/${bowlerId}`)}>
          <span>{'National Id'}</span>
          <span>{bowlerNationalId}</span>
        </a>
        <div className="list-group-item-labeled-child"
          style={{ width: 325 }}>
          <span>{'Teams'}</span>
          <span>{teamName}</span>
        </div>
        <div className="list-group-item-labeled-child"
          style={{ width: 250 }}>
          <span>{'Captains'}</span>
          <span>{captainName}</span>
        </div>
        {
          <div className="list-group-item-labeled-child"
            style={{ width: 210 }}>
            <span>{coordinatorName && coordinatorName.trim().length > 0 ? 'Coordinators' : 'No coordinator'}</span>
            <span>{coordinatorName}</span>
          </div>
        }
      </div>
    );

  return (
    <div className="list-group-item-labeled">
      <div className="list-group-item-labeled-child"
        style={{ width: 200 }}>
        <span>{'Tournament'}</span>
        <span>{`${tournamentName}`}</span>
      </div>
      <div className="list-group-item-labeled-child"
        style={{ width: 200 }}>
        <span>{'Name'}</span>
        <span>{`${bowlerName}`}</span>
      </div>
      <a className="list-group-item-labeled-child has-link"
        style={{ width: 80 }}
        onClick={() => onNavigationClick(`admin/audit/bowler/${bowlerId}`)}>
        <span>{'National Id'}</span>
        <span>{bowlerNationalId}</span>
      </a>
    </div>
  );
};

AuditSearchBowler.propTypes = {
  addressBase: PropTypes.string,
  bowlerId: PropTypes.string,
  bowlerNationalId: PropTypes.string,
  bowlerName: PropTypes.string,
  teamName: PropTypes.string,
  entryNumber: PropTypes.string,
  entryId: PropTypes.string,
  tournamentId: PropTypes.string,
  tournamentName: PropTypes.string,
  captainName: PropTypes.string,
  coordinatorName: PropTypes.string,
  onNavigationClick: PropTypes.func
};

AuditSearchBowler.defaultProps = {
};

export default AuditSearchBowler;



// WEBPACK FOOTER //
// ./src/features/admin/audit/bowlerAudit/AuditSearchBowler.jsx